import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getSafe } from "@/helpers/global";
import { bcanConsentAction } from "@/actions/auth";
import { SERVICES_RESP, Icons } from "@/configurations";
import { PATH } from "@/constants/paths";
import { openImportantNotesDialog } from "@/actions/app/dialog.action";
import QueryString from 'query-string'
import "@/companys/eif/assets/styles/pages/bcan.scss";
import { switchLanguage } from '@/actions/app';
import icon_successIcon from '@/assets/images/icons/changepassword_success.png'
import { isDevelopment } from '@/helpers/global/env.func.js'


const en_USbcanHTML = isDevelopment() ? "src/companys/eif/assets/html/Important_Notice_English.html" : "static/html/Important_Notice_English.html";
const zh_CNbcanHTML = isDevelopment() ? "src/companys/eif/assets/html/Important_Notice_Simplified.html" : "static/html/Important_Notice_Simplified.html";
const zh_TWbcanHTML = isDevelopment() ? "src/companys/eif/assets/html/Important_Notice_Traditional.html" : "static/html/Important_Notice_Traditional.html";
const ChangeClientInformationFormEN = 'https://www.eif.com.hk/en/faq/forms'
const ChangeClientInformationFormZH = 'https://www.eif.com.hk/zh/faq/forms'

class BCAN extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isloding: false,
      issucess: false
    };
  }
  render() {
    const { language } = this.props;
    const { issucess } = this.state;
    return (
      <React.Fragment>
        {!issucess && <div
          className="bcan-content"
          style={{ background: "#232c37", margin: "25px auto 0" }}
        >
          {this[`${language.lang}iframe`]()}

        </div>}
        {issucess &&
          <div className="success-container">
            <div>
              <img src={icon_successIcon}></img>
              <div style={{ marginBottom: '5px' }}>{language.bcan_submit_sucess}</div>
              <div>{language.bcan_sucess_message}</div>
            </div>
            <button onClick={() => this.props.history.push(PATH.TRADE)}>{language.common_confirm}</button>
          </div>
        }
      </React.Fragment>
    );
  }

  en_USiframe() {
    const en_USHTML = en_USbcanHTML + '?' + ChangeClientInformationFormEN
    return (
      <iframe
        id="iframe"
        name="iframe"
        width="100%"
        height={this.props.isMobile ? '100%' : '700px'}
        scrolling="no"
        src={en_USHTML}
        frameborder="no"
        onLoad={() => this.clickLoad()}
      ></iframe>
    );
  }
  zh_TWiframe() {
    const zh_TWHTML = zh_TWbcanHTML + '?' + ChangeClientInformationFormZH

    return (
      <iframe
        id="iframe"
        name="iframe"
        width="100%"
        height={this.props.isMobile ? '100%' : '700px'}
        scrolling="no"
        src={zh_TWHTML}
        frameborder="no"
        onLoad={() => this.clickLoad()}
      ></iframe>
    );
  }
  zh_CNiframe() {
    const zh_CNHTML = zh_CNbcanHTML + '?' + ChangeClientInformationFormZH


    return (
      <iframe
        id="iframe"
        name="iframe"
        width="100%"
        height={this.props.isMobile ? '100%' : '700px'}
        scrolling="no"
        src={zh_CNHTML}
        frameborder="no"
        onLoad={() => this.clickLoad()}
      ></iframe>
    );
  }

  bcanConsentCancel = () => {
    this.props.history.push(PATH.TRADE);
    this.openImportantNotes();
  };

  openImportantNotes = () => {
    const passwordExpired = this.props.location.state.passwordExpired;
    if (passwordExpired) {
      setTimeout(() => openImportantNotesDialog({ passwordExpired }), 500);
    }
  };

  clickLoad() {
    const iframe = document.getElementById("iframe").contentDocument
    let isCheck = false
    // iframe.getElementById("agree").addEventListener('click', () => {
    //   isCheck = iframe.getElementById("agree").checked
    //   if (isCheck) {
    //     iframe.getElementById("errorMessage").style.display = 'none';
    //   }
    // })

    iframe.getElementById("ConfirmButton").addEventListener('click', () => {
      // isCheck = iframe.getElementById("agree").checked
      // if (isCheck) {
      if (this.state.isloding) return
      this.bcanConsentConfirm()
      // } else {
      // iframe.getElementById("errorMessage").style.display = 'inline';
      // }
    })

    iframe.getElementById("CancelButton").addEventListener('click', () => {
      if (this.state.isloding) return
      this.bcanConsentCancel()
    })

    iframe.getElementsByClassName('language-change')[0]?.addEventListener('click', () => {
      this.props.switchLanguage({ value: 'en' })
    })
  }

  bcanConsentConfirm() {
    const params = { marketID: 'HKEX', bcanConsent: "Y" }
    // const params = {}
    const iframe = document.getElementById("iframe").contentWindow
    this.setState({ isloding: true }, () => {
      iframe.postMessage({ load: 'true' })
    })
    this.props.bcanConsentAction(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          this.setState({ issucess: true })
        } else {
          this.setState({ isloding: false }, () => {
            iframe.postMessage(res.result.errorMessage)
            iframe.postMessage({ load: 'false' })
          })
        }
      } else {
        this.setState({ isloding: false }, () => {
          if (res.result.errorMessage) {
            iframe.postMessage(res.result.errorMessage)
          }
          iframe.postMessage({ load: 'false' })
        })
      }
    })
  }

  bcanConsentCancel = () => {
    this.props.history.push(PATH.TRADE)
  }

  componentDidMount() {
    if (document.getElementsByClassName('content')[0]) {
      document.getElementsByClassName('content')[0].style.flex = '1'
    }
  }

  componentWillUnmount() {
    if (document.getElementsByClassName('content')[0]) {
      document.getElementsByClassName('content')[0].style.flex = 'unset'
    }
  }

}

export default withRouter(
  connect(
    (state) => ({
      language: state.app.language,
      isMobile: state.app.isMobile,
    }),
    (dispatch) => ({
      bcanConsentAction: (p, c) => dispatch(bcanConsentAction(p, c)),
      switchLanguage: (p) => dispatch(switchLanguage(p)),
    })
  )(BCAN)
);
